import styled from "styled-components";

export const Content = styled.div`
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .content_button {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;

        .button {
            margin: 50px 0;
            font-size: 16px;
            color: #fff;
            line-height: 1.2;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0 20px;
            min-width: 120px;
            height: 50px;
            border-radius: 8px;
            background: var(--green-main);
            position: relative;
            z-index: 1;
            transition: all .4s;
        }
    }
`;